import { Cloud } from '@cast/shared-types';
import { EdgeLocation } from '@cast/types-omni';

import { CUSTOM_EDGE_PROVIDER } from './constants';

export enum EdgeLocationAddonName {
  NvidiaGpuOperator = 'nvidia-gpu-operator',
  NvidiaDra = 'nvidia-dra',
  NvidiaNetworkOperator = 'nvidia-network-operator',
  OciCsi = 'oci-csi',
}

export enum EdgeLocationMappedState {
  Pending = 'Pending',
  InUse = 'In use',
  Offboarding = 'Offboarding',
  Failed = 'Failed',
  Deleted = 'Deleted',
  Ready = 'Ready',
  Unknown = 'Unknown',
}

export type EdgeLocationProvider =
  | Cloud.gcp
  | Cloud.aws
  | Cloud.oracle
  | Cloud.nebius
  | Cloud.unknown
  | typeof CUSTOM_EDGE_PROVIDER;

export type AddonFormValue = {
  enabled: boolean;
  /** Raw JSON editor text of Helm values */
  values?: string;
};

export type EdgeLocationFormValues = {
  provider: EdgeLocationProvider;
  region: string;
  locationName: string;
  description: string;
  projectId: string;
  /** Keyed by addon name */
  addons: Record<string, AddonFormValue>;
};

export type EdgeLocationInitialData = {
  provider?: string;
  region?: string;
  providerProjectId?: string;
};

export type EdgeLocationTemplateUsage = {
  totalUsed: number;
  totalEnabled: number;
  templateNames: string[];
};

export type EnhancedEdgeLocation = EdgeLocation & {
  mappedState: EdgeLocationMappedState;
  templateUsage: EdgeLocationTemplateUsage;
  provider: EdgeLocationProvider;
};

export type EdgeLocationRegion = {
  region?: string;
  provider: EdgeLocationProvider;
};

/**
 * Edge location providers where Cast AI manages cloud resources and can provision instance directly.
 * Excludes CUSTOM (user-provided instances joined via manual script installation,
 * with no cloud resources for Cast AI to create or manage).
 * The type is used to filter locations and their configs in autoscaler-driven contexts
 * (node template selection, edge configuration CRUD).
 */
export type CastManagedEdgeLocationProvider = Exclude<
  EdgeLocationProvider,
  typeof CUSTOM_EDGE_PROVIDER
>;
